<!--
 * @Author: Cathy
 * @Date: 2020-02-25 17:13:21
 * @LastEditors: Cathy
 * @LastEditTime: 2020-03-19 15:30:54
 * @Description: 下载联吧组件
 -->
<template>
<div class="lianbaDownLoad">
  <div class="downLoad" @click="onDownload">
    下载联吧
  </div>
  <isWeixinMark :isWeixin="isWeixin" @onCancelMark="isWeixin = false" />
</div>
</template>

<script>
import isWeixinMark from './isWeixinMark'
export default {
  name: 'lianbaDownLoad',
  components: {
    isWeixinMark
  },
  props: {
    downloadLink: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isWeixin: false
    }
  },
  methods: {
    onDownload () {
      const u = window.navigator.userAgent
      this.isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // android终端或者uc浏览器
      const isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isIos) {
        location.href = 'https://apps.apple.com/cn/app/%E8%81%94%E5%90%A7/id1404140841'
      }
      if (isAndroid) {
        if (!this.isWeixin) {
          console.log(this.downloadLink)

          location.href = this.downloadLink
        }
      }
    }
  }
}
</script>

<style scoped>
.downLoad {
position: fixed;
bottom: 25%;
right: 3%;
width:1.37rem;
height:1.15rem;
background:rgba(250,170,34,1);
border-radius:0.16rem;
color: #fff;
font-size: 0.36rem;
display: flex;
align-items: center;
justify-content: center;
padding: 0 0.3rem;
z-index: 999;
}
</style>
